import { Component, OnInit } from '@angular/core';
import { IonicSelectableComponent } from 'ionic-selectable';
import {ServicioLoadersAlertasService} from '../servicio-loaders-alertas.service'
import {GranServicioDePTWService} from '../gran-servicio-de-ptw.service'
import * as firebase from 'firebase'
import { Router } from '@angular/router';
import {TimelineComponent}from '../timeline/timeline.component'


//ionic-selectable
class AutoridadHSE{
  public id: number;
  public name: string;
  public email: string;
  public regional: string
}

//ionic-selectable
class AutoridadAislante{
  public id: number;
  public name: string;
  public email: string;
  public regional: string
}



@Component({
  selector: 'app-paso6page',
  templateUrl: './paso6page.page.html',
  styleUrls: ['./paso6page.page.scss'],
})
export class Paso6pagePage implements OnInit {


  requiereAutoridadAislante=false
  

  //ionic-selectable
  listadeAutoridadesHSE: AutoridadHSE[];
  objetodeAutoridadesHSE: AutoridadHSE;
    
  //ionic-selectable
  listadeAutoridadesAislantes: AutoridadAislante[];
  objetodeAutoridadesAislantes: AutoridadAislante;

  autoridadHSESeleccionada=undefined
  emailautoridadHSESeleccionada=''
  autoridadAislanteSeleccionada=undefined
  emailautoridadAislanteSeleccionada=''


  constructor(public servicioLoadersAlertasService:ServicioLoadersAlertasService, private router:Router, public granServicioDePTWService:GranServicioDePTWService,public timelineComponent:TimelineComponent) { 

  }

  ngOnInit() {

  }
  
  ionViewWillEnter(){
    this.timelineComponent.actualizar()
    this.cargaAutoridades()
    this.granServicioDePTWService.cargadatosdePTW((respuesta)=>{
      this.autoridadHSESeleccionada=respuesta.data().autoridadHSE
      this.autoridadAislanteSeleccionada=respuesta.data().autoridadAislante
      if(respuesta.data().autoridadAislante == undefined){
        this.requiereAutoridadAislante=false
      }
    })
  }

  


cargaAutoridades(){

    this.servicioLoadersAlertasService.presentLoading("Cargando autoridades")
    this.listadeAutoridadesHSE = [];
    this.listadeAutoridadesAislantes = [];
    
     let querydeafes = firebase.firestore().collection("autoridades");
     querydeafes.get().then((docs) => {
       docs.forEach((doc) => {
        if(doc.data().autoridadHSE == true){
          this.listadeAutoridadesHSE.push( { id:this.listadeAutoridadesHSE.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
        }else 
        if(doc.data().autoridadAislante == true){
          this.listadeAutoridadesAislantes.push( { id:this.listadeAutoridadesAislantes.length-1 , name: doc.data().nombre, email: doc.data().email, regional:doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
        } 
       });
       this.servicioLoadersAlertasService.loadingController.dismiss()
     }).catch((err) => {
       console.log(err);
     });
  }

  navegar(entrada){
    this.router.navigateByUrl(entrada);
 } 

  regresar(){
    this.navegar("/paso5page")
   }

   autoridadChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    this.autoridadHSESeleccionada={nombre:event.value.name, email:event.value.email, regional:event.value.regional};
    this.emailautoridadHSESeleccionada=event.value.email
  }


  autoridadAislanteChange(event: {
    component: IonicSelectableComponent,
    value: any
  }) {
    // console.log('pozo:', event.value);
    this.autoridadAislanteSeleccionada={nombre:event.value.name, email:event.value.email, regional:event.value.regional};
    this.emailautoridadAislanteSeleccionada=event.value.email
  }

  terminar(){
      if(this.autoridadHSESeleccionada!=undefined ){
        this.updateFirebase()
      }else
      if(this.autoridadHSESeleccionada ==undefined ){
        this.servicioLoadersAlertasService.alerta("Autoridad HSE no seleccionada","Seleccione una autoridad HSE para poder continuar.")
      }
  }

   updateFirebase(){
      firebase.firestore().collection("ptws").doc(this.granServicioDePTWService.idSolicitud).update(
            {
              autoridadHSE: this.autoridadHSESeleccionada,
              emailautoridadHSE: this.emailautoridadHSESeleccionada,
              enviado: firebase.firestore.FieldValue.serverTimestamp(),
              "objetoPasosCompletados.paso6":"ok"
            }
        )
      .then(()=>{
          this.servicioLoadersAlertasService.presentToast("¡Autoridad HSE asignada!")
          this.navegar("/paso7page")
      }).catch((err)=>{
        this.servicioLoadersAlertasService.alerta("Error",err)
      })
   }

   volveramenu(){
    this.navegar("/menu")
   }

}
